import { EventEmitter, Injectable } from "@angular/core";
import * as signalR from "@microsoft/signalr";
import { environment } from "../../../environments/environment";
import { SessionService } from "../session.service";

const URL = `${environment.backendBaseUrl}/ws-hub`
const RETRY_EVENT = "paymentError"
const REJECT_EVENT = "paymentRejected"
const SUCCESS_EVENT = "paymentSuccess"

@Injectable({
  providedIn: "root"
})
export class TransferHub {
  public hubConnection: signalR.HubConnection;

  public transferRetryEventEmitter: EventEmitter<boolean>;
  public transferRejectedEventEmitter: EventEmitter<boolean>;
  public transferSuccessEventEmitter: EventEmitter<boolean>;

  constructor(private session: SessionService) {
    this.transferRetryEventEmitter = new EventEmitter<boolean>();
    this.transferRejectedEventEmitter = new EventEmitter<boolean>();
    this.transferSuccessEventEmitter = new EventEmitter<boolean>();
  }

  public buildConnection() {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(URL, {
        accessTokenFactory: () => this.session.getAuthToken()
      })
      .withAutomaticReconnect()
      .build();
  }

  public startConnection() {
    this.hubConnection.start().then(() => {
      this.registerSignalEvents();
    });
  }

  private registerSignalEvents() {
    this.hubConnection.on(RETRY_EVENT, () => {
      console.log("RETRY")
      this.transferRetryEventEmitter.emit(true);
    });

    this.hubConnection.on(REJECT_EVENT, () => {
      console.log("REJECT")
      this.transferRejectedEventEmitter.emit(true);
    });

    this.hubConnection.on(SUCCESS_EVENT, () => {
      console.log("SUCCESS")
      this.transferSuccessEventEmitter.emit(true);
    });
  }
}
